import * as React from 'react';
import GridContainer from "../GenericComponents/Grids/GridContainer";
import {createBreadCrumbBasedOnPage} from "../../Utils/HelperFunctions";
import * as actionTypes from "../../store/action";
import {connect} from "react-redux";

interface ZoneProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
}

interface ZoneState {
}

class Zone extends React.Component<ZoneProps,ZoneState> {

    constructor(props: ZoneProps) {
        super(props);
    }

    componentDidMount(): void {
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));
    }

    render() {
        return (
            <GridContainer
                getGridDataUrl={'/api/auth/viewGridData/zone'}
                addRecordUrl={'/api/auth/saveGridRecord/zone'}
                editRecordUrl={'/api/auth/editGridRecord/zone'}
                gridPaginated={false}
                formEditing={true}
                exportLink={'viewGridData/zone'}
                gridTitle={'Zone'}
                gridId={'zoneGrid'}
                showUtilityColumns={true}
                typeForSuperClass={'zone'}
            />
        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(null, mapDispatchToProps)(Zone);